module.exports = __webpack_public_path__ + "img/hdp-portfolio-2.734cf42f.jpg";